import Alticelabs from '../../assets/icons/partners/alticelabs.png';
import Exfo from '../../assets/icons/partners/exfo.png';
import Genexis from '../../assets/icons/partners/genexis.png';
import Hellenic from '../../assets/icons/partners/hellenic.png';
import Kaspersky from '../../assets/icons/partners/kaspersky.png';
 
import Icotera from '../../assets/icons/partners/lecotera.png';
import Linksys from '../../assets/icons/partners/linksys.png';
import Malewarebytes from '../../assets/icons/partners/malewarebytes.png';
import Nestor from '../../assets/icons/partners/nestor.png';
import Netadmin from '../../assets/icons/partners/netadmin.png';
 
import NNO from '../../assets/icons/partners/nno.png';
import NVM from '../../assets/icons/partners/nvm.png';
import Paloalto from '../../assets/icons/partners/paloalto.png';
import Sitetracker from '../../assets/icons/partners/sitetracker.png';
import Solarwinds from '../../assets/icons/partners/solarwinds.png';
 
import Spatialnetwork from '../../assets/icons/partners/spatialnetwork.png';
import Stratodesk from '../../assets/icons/partners/stratodesk.png';
import Sumitomo from '../../assets/icons/partners/sumitomo.png';
import Tplink from '../../assets/icons/partners/tplink.png';
import Trendmicro from '../../assets/icons/partners/trendmicro.png';
 
import Zyxel from '../../assets/icons/partners/zyxel.png';
import ZTT from '../../assets/icons/partners/zzt.png';

const partners = [
  { name: 'Alticelabs', logo: Alticelabs, url: 'https://www.alticelabs.com/' },        
  { name: 'Exfo', logo: Exfo, url: 'https://www.exfo.com/' },                            
  { name: 'Genexis', logo: Genexis, url: 'https://genexis.eu/' },                      
  { name: 'Hellenic', logo: Hellenic, url: 'https://www.hellenic-cables.com/' },              
  { name: 'Kaspersky', logo: Kaspersky, url: 'https://www.kaspersky.com/' },          
 
  { name: 'Icotera', logo: Icotera, url: 'https://icotera.com/' },                  
  { name: 'Linksys', logo: Linksys, url: 'https://www.linksys.com/' },                  
  { name: 'Malewarebytes', logo: Malewarebytes, url: 'https://www.malwarebytes.com/' },
  { name: 'Nestor', logo: Nestor, url: 'https://www.nestorcables.com/' },                    
  { name: 'Netadmin', logo: Netadmin, url: 'https://www.netadminsystems.com/' },            
 
  { name: 'NNO', logo: NNO, url: 'https://innoinstrument.com/' },                          
  { name: 'NVM', logo: NVM, url: 'https://www.nvm.com/' },                          
  { name: 'Paloalto', logo: Paloalto, url: 'https://www.paloaltonetworks.com/' },    
  { name: 'Sitetracker', logo: Sitetracker, url: 'https://www.sitetracker.com/' },      
  { name: 'Solarwinds', logo: Solarwinds, url: 'https://www.solarwinds.com/' },        
 
  { name: 'Spatialnetwork', logo: Spatialnetwork, url: 'https://www.spatialnetworx.ai/' },
  { name: 'Stratodesk', logo: Stratodesk, url: 'https://www.stratodesk.com/' },        
  { name: 'Sumitomo', logo: Sumitomo, url: 'https://global-sei.com/' },              
  { name: 'Tplink', logo: Tplink, url: 'https://www.tp-link.com/' },                  
  { name: 'Trendmicro', logo: Trendmicro, url: 'https://www.trendmicro.com/' },      
 
  { name: 'Zyxel', logo: Zyxel, url: 'https://www.zyxel.com/' },                      
  { name: 'ZTT', logo: ZTT, url: 'https://www.zttgroup.com/' },                          
];
 
export default partners;